import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { noteActions, alertActions } from '_actions';

class DBROMField extends React.Component {
    constructor() {
        super();
        this.state = {
            value: '',
            changingTimeout: 0,
            hasChanges: false
        };
        this.handleValueChange = this.handleValueChange.bind(this);
        this.handleOnBlur = this.handleOnBlur.bind(this);
        this.saveValue = this.saveValue.bind(this);
    }

    componentDidMount() {
        this.setState((state) => {
            return { value: this.props.value };
        })
    }

    componentDidUpdate(prevProps) {
        if (this.props.noteId !== prevProps.noteId ||
            this.props.entity !== prevProps.entity ||
            this.props.entityKeyValue !== prevProps.entityKeyValue ||
            this.props.value !== prevProps.value ||
            this.props.field !== prevProps.field) {
            this.setState((state) => {
                return { value: this.props.value, hasChanges: false };
            })
        }
    }

    handleValueChange(event) {
        if (this.state.changingTimeout) {
            clearTimeout(this.state.changingTimeout);
        }

        this.setState({
            value: event.target.value,
            hasChanges: true,
            changingTimeout: setTimeout(() => this.saveValue(), 2000)
        });
    }

    saveValue() {
        let val = this.state.value;
        if ((typeof val === 'string' || val instanceof String)) {
            if (val.startsWith('+')) {
                val = val.substring(1);
            }
            val = val.trim();
        }

        this.setState({
            value: val,
        });

        let tmpVal = this.state.value;
        if (tmpVal.endsWith('*')) {
            tmpVal = tmpVal.substring(0, tmpVal.length - 1);
            tmpVal = tmpVal.trim();
        }


        if (this.state.hasChanges === true) {
            if (this.state.value === '') {
                this.props.clearField(this.props.noteId, this.props.entity, this.props.entityKeyColumn, this.props.entityKeyValue, this.props.field);
            } else if (
                this.state.value.toUpperCase() === 'WNL'
                || this.state.value.toUpperCase() === 'WFL'
                || this.state.value.toUpperCase() === 'WNL*'
                || this.state.value.toUpperCase() === 'WFL*'
                || this.state.value.toUpperCase() === 'WNL *'
                || this.state.value.toUpperCase() === 'WFL *'
            ) {
                this.props.updateTextField(this.props.noteId, this.props.entity, this.props.entityKeyColumn, this.props.entityKeyValue, this.props.field, this.state.value);
            } else if (this.state.value.includes('.') && !this.props.field.includes('ROTMJ')) {
                // (this.props.field !== 'ROTMJOPENINGPROM' &&  this.props.field !== 'ROTMJOPENINGAROM' && this.props.field !== 'ROTMJPROTRUSIONPROM' && this.props.field !== 'ROTMJPROTRUSIONAROM' && this.props.field !== 'ROTMJRETRACTIONPROM' &&  this.props.field !== 'ROTMJRETRACTIONAROM' && this.props.field !== 'ROTMJLATEXCURSIONPROM' && this.props.field !== 'ROTMJLATEXCURSIONAROM' && this.props.field !== 'ROTMJLATEXCURSIONAROMR' &&  this.props.field !== 'ROTMJLATEXCURSIONAROML' && this.props.field !== 'ROTMJLATEXCURSIONPROMR' && this.props.field !== 'ROTMJLATEXCURSIONPROML')) {
                this.props.alertWarning('No decimal places allowed.')
                this.setState({ value: this.props.value, hasChanges: false });
            } else if (!Number.isFinite(parseFloat(this.state.value.replace("*", ""))) && this.props.field.includes('ROTMJ')) {
                this.props.alertWarning('Input is invalid.')
                this.setState({ value: this.props.value, hasChanges: false });
            } else if (this.state.value.length > 6 && this.props.field.includes('ROTMJ')) {
                this.props.alertWarning('Number too large.')
            } else if (isNaN(tmpVal)) {
                this.props.alertWarning('Input is invalid');
                this.setState({ value: this.props.value, hasChanges: false });
            } else if (this.props.min !== undefined && this.props.min !== null && parseInt(tmpVal) < this.props.min) {
                this.props.alertWarning('The minimum value for this field is: ' + this.props.min);
                this.setState({ value: this.props.value, hasChanges: false });
            } else if (this.props.max !== undefined && this.props.max !== null && parseInt(tmpVal) > this.props.max) {
                this.props.alertWarning('The maximum value for this field is: ' + this.props.max);
                this.setState({ value: this.props.value, hasChanges: false });
            } else if (val.trim() === '*') {
                this.props.alertWarning('Input is invalid');
                this.setState({ value: this.props.value, hasChanges: false });
            } else {
                this.props.updateTextField(this.props.noteId, this.props.entity, this.props.entityKeyColumn, this.props.entityKeyValue, this.props.field, this.state.value);
            }

            if (this.props.onChange) {
                this.props.onChange(this.state.value);
            }
        }
        this.setState({ hasChanges: false });
    }

    handleOnBlur() {
        let isValid = false;
        let tmpVal = this.state.value;
        if (tmpVal.endsWith('*')) {
            tmpVal = tmpVal.substring(0, tmpVal.length - 1);
            tmpVal = tmpVal.trim();
        }

        if (
            this.state.value.toUpperCase() === 'WNL'
            || this.state.value.toUpperCase() === 'WFL'
            || this.state.value.toUpperCase() === 'WNL*'
            || this.state.value.toUpperCase() === 'WFL*'
            || this.state.value.toUpperCase() === 'WNL *'
            || this.state.value.toUpperCase() === 'WFL *'
        ) {
            isValid = true;
        } else if (this.state.value.includes('.')) {
            isValid = false;
        } else if (isNaN(tmpVal)) {
            isValid = false;
        } else if (this.props.min !== undefined && this.props.min !== null && parseInt(tmpVal) < this.props.min) {
            isValid = false;
        } else if (this.props.max !== undefined && this.props.max !== null && parseInt(tmpVal) > this.props.max) {
            isValid = false;
        } else if (this.state.value.trim() === '*') {
            isValid = false;
        }

        if (this.state.value !== '' && !isValid) {
            this.setState({ value: this.props.value });
        }
        this.saveValue();
        clearTimeout(this.state.changingTimeout);

    }

    render() {
        return (
            <input
                className={this.props.className ? this.props.className : ''}
                type='text'
                // min={this.props.min}
                // max={this.props.max}
                title={this.props.title ? this.props.title : ''}
                onChange={this.handleValueChange}
                onBlur={this.handleOnBlur}
                value={this.state.value} />
        );
    }
}

function mapDispatchToProps(dispatch) {
    return {
        updateTextField: bindActionCreators(noteActions.updateTextField, dispatch),
        clearField: bindActionCreators(noteActions.clearField, dispatch),
        alertWarning: bindActionCreators(alertActions.warningMsg, dispatch)

    };
}

function mapStateToProps(state, ownprops) {
    return {
        value: state.entities.notes[ownprops.entity][ownprops.entityKeyValue][ownprops.field] !== undefined
            && state.entities.notes[ownprops.entity][ownprops.entityKeyValue][ownprops.field] !== null ?
            state.entities.notes[ownprops.entity][ownprops.entityKeyValue][ownprops.field] : ''
    };
}

const connectedDBROMField = connect(mapStateToProps, mapDispatchToProps)(DBROMField);
export { connectedDBROMField as DBROMField };